var _excluded = ["allowsNewSelection", "isClearable", "name", "onBlur", "onChange", "options", "placeholder", "readOnly", "noOptionsMessage", "sort", "value", "wrapper", "maxLength", "translateTheOptions", "skipPlaceholder", "optionComponent", "valueRenderer", "selectStyles"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import Select, { components } from 'react-select';
import { useTranslate } from 'shared/helper/translate';
import reactSelectStyle from 'shared/helper/reactSelectStyle';
var interpretValue = function interpretValue(value, options) {
  if (!value || !value.value) {
    return null;
  }
  return options.find(function (option) {
    return option.value === value.value;
  }) || value;
};
var translateOptions = function translateOptions(t, options) {
  var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var newOptions = options.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      label: t(option.label),
      value: option.value
    });
  });
  return sort ? newOptions.sort(function (a, b) {
    return a.label < b.label ? -1 : 1;
  }) : newOptions;
};
var handleChangeEvent = function handleChangeEvent() {
  var changeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return function (value) {
    return changeEvent(value === null ? {
      value: ''
    } : value);
  };
};
var CommonSelect = function CommonSelect(_ref) {
  var allowsNewSelection = _ref.allowsNewSelection,
    isClearable = _ref.isClearable,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    _noOptionsMessage = _ref.noOptionsMessage,
    sort = _ref.sort,
    value = _ref.value,
    _ref$wrapper = _ref.wrapper,
    Wrapper = _ref$wrapper === void 0 ? Select : _ref$wrapper,
    maxLength = _ref.maxLength,
    _ref$translateTheOpti = _ref.translateTheOptions,
    translateTheOptions = _ref$translateTheOpti === void 0 ? true : _ref$translateTheOpti,
    _ref$skipPlaceholder = _ref.skipPlaceholder,
    skipPlaceholder = _ref$skipPlaceholder === void 0 ? false : _ref$skipPlaceholder,
    optionComponent = _ref.optionComponent,
    _ref$valueRenderer = _ref.valueRenderer,
    valueRenderer = _ref$valueRenderer === void 0 ? '' : _ref$valueRenderer,
    _ref$selectStyles = _ref.selectStyles,
    selectStyles = _ref$selectStyles === void 0 ? {} : _ref$selectStyles,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var selectStyle = _objectSpread(_objectSpread({}, reactSelectStyle), selectStyles);
  var translatedOptions = translateTheOptions ? translateOptions(t, options, sort) : options;
  var updatedPlaceholder = skipPlaceholder ? '' : t(placeholder || '-- Please select --');
  var componentObject = {
    // eslint-disable-next-line react/jsx-props-no-spreading
    Input: function Input(props) {
      return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, {
        maxLength: maxLength
      }));
    }
  };
  if (optionComponent) {
    componentObject.Option = optionComponent;
  }
  if (valueRenderer) {
    componentObject.ValueContainer = valueRenderer;
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "aria-label": "Choose an option",
    "aria-live": "polite",
    className: "dropdown",
    isClearable: isClearable,
    isDisabled: readOnly,
    components: componentObject,
    name: name,
    onBlur: handleChangeEvent(onBlur),
    onChange: handleChangeEvent(onChange),
    options: translatedOptions,
    placeholder: updatedPlaceholder,
    noOptionsMessage: function noOptionsMessage() {
      return t(_noOptionsMessage || '');
    },
    value: interpretValue(value, translatedOptions),
    styles: selectStyle,
    formatCreateLabel: allowsNewSelection ? function (value) {
      return t('Create option "%s"', value);
    } : undefined
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest));
};
export default CommonSelect;